import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import withMenuState from './hoc/withMenuState';
import arrow from '../images/arrow.png';

const Wrapper = styled.div`
  background-color: ${props => props.theme.colors.inputBackground};
  position: relative;
  height: 62px;
`;

const Container = styled.div`
  position: absolute;
  width: 100%;

  &::after {
    content: "";
    background-image: url(${arrow});
    background-repeat: no-repeat;
    width: 13px;
    height: 9px;
    position: absolute;
    top: 26px;
    right: 23px;
  }

  transition: box-shadow 0.4s;

  ${props => props.isOpen && `
    box-shadow: 5px 5px 18px rgba(0,0,0,0.4);
    z-index: 1000;
  `}
`;

const Option = styled.div`
  background-color: ${props => props.theme.colors.inputBackground};
  color: ${props => props.theme.colors.normalText};
  height: ${props => props.selected || props.isOpen ? '62px' : '0px'};
  overflow: hidden;
  font-size: 1.6rem;
  cursor: pointer;
  text-align: left;
  padding-left: 20px;
  line-height: 62px;

  &:hover {
    background-color: ${props => props.theme.colors.inputHighlightBackground};
    transition: background-color 0.7s;
  }

  transition: height 0.4s, background-color 3s;
`;

class DropDown extends React.Component {
  render() {

    const {
      value,
      placeholder,
      options,
      onChange,
      menuState: {
        activeDropdown,
        setActiveDropdown,
      },
    } = this.props;

    return (
      <Wrapper>
        <Container isOpen={this === activeDropdown}>

          <Option
            selected={!value}
            onClick={(e) => {
              setActiveDropdown(this);
              // Prevent global click handler from closing menu:
              e.stopPropagation();
            }}
          >{placeholder}</Option>

          {options.map(option => (
            <Option
              key={option}
              selected={value === option}
              isOpen={this === activeDropdown}
              onClick={(e) => {

                // Prevent global click handler from closing menu:
                e.stopPropagation();

                if (this === activeDropdown) {
                  // Notify parent of option selection:
                  onChange(option);
                  // Close dropdown:
                  setActiveDropdown(null);
                } else {
                  // Open dropdown:
                  setActiveDropdown(this);
                }

                return false;

              }}
            >{option}</Option>
          ))}
        </Container>
      </Wrapper>
    );
  }
}

DropDown.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

DropDown.defaultProps = {
  value: "",
  placeholder: "Please select one",
};

export default withMenuState(DropDown);
